import { render, staticRenderFns } from "./Altura.vue?vue&type=template&id=18715a36&"
import script from "./Altura.vue?vue&type=script&lang=js&"
export * from "./Altura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports